export const FETCH_ALLEXPENSE_REQUEST = 'FETCH_ALLEXPENSE_REQUEST'
export const FETCH_ALLEXPENSE_SUCCESS = 'FETCH_ALLEXPENSE_SUCCESS'
export const FETCH_ALLEXPENSE_FALIURE = 'FETCH_ALLEXPENSE_FALIURE'
